export default "__VITE_ASSET__or0M0ImW__"